import React from "react";

const Process = () => {
  return (
    <>
      <div className="process-head">
        <div className="container-fluid">
          <div className="row">
            <div class="col-lg-12 process py-5">
              <h1 className="d-flex justify-content-center text-center process-text">
                <strong> How GAUSWARN Prepare GIR Cow Ghee </strong>
              </h1>
              <h2 className="text-center process-text">Using Bilona Method</h2>
              <div className="processImg">
                <p className="process-text1 fw-bold"> Making Gir Cow Milk</p>
                <p className="process-text2 fw-bold">
                  Heating up Milk to form CURD
                </p>
                <p className="process-text3 fw-bold">
                  Resting Milk to make CURD
                </p>
                <p className="process-text4 fw-bold">
                  Churning curd with BILONA to form makhan
                </p>
                <p className="process-text5 fw-bold">Makhan is extracted</p>
                <p className="process-text6 fw-bold">
                  Extracted makhan is heated
                  to get the Best Quality GIR cow ghee
                </p>
                <p className="process-text7 fw-bold">
                  Delicious ghee with health benefits is ready to serve
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Process;
